import React from "react";
import cancel from "../assets/images/navbar/cancel.png";
import arrow from "../assets/images/order/orange-arrow.png";

type WelcomeProps = {
  isOpen: boolean;
  onClose: () => void;
  count?: number;
};

const Welcome: React.FC<WelcomeProps> = ({ isOpen, onClose, count }) => {
  const [userName, setUserName] = React.useState("Aman Bansal");
  const [selectedCategories, setSelectedCategories] = React.useState<string[]>(
    [],
  );
  const categories: string[] = [
    "Pizza",
    "Burger",
    "Indian",
    "Chinese",
    "Thai",
    "Vegetarian",
    "Lunch",
    "Kebab",
    "Biryani",
    "Dosa",
    "Breakfast",
    "Non Veg",
  ];

  const toggleCategory = (category: string) => {
    setSelectedCategories((prev) =>
      prev.includes(category)
        ? prev.filter((c) => c !== category)
        : [...prev, category],
    );
  };
  if (!isOpen) return null;
  return (
    <>
      {/* Backdrop Overlay */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-[1001]"
        onClick={onClose}
      />

      {/* Modal Container */}
      <div className="fixed inset-0 flex items-center justify-center z-[1002] pointer-events-none">
        <div
          className="w-[545px] p-6 rounded-[24px] bg-white pointer-events-auto relative"
          style={{
            boxShadow: "-23px 23px 72px 0 rgba(0, 0, 0, 0.15)",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Modal Content */}
          <div className="w-full mt-[24px] ">
            {/* welcome */}
            <div className="space-y-[8px]">
              <p className="text-[#050505] font-Urbanist text-[32px] font-semibold leading-[125%]">
                Welcome to Duddus 🎉
              </p>
              <p className="text-[#6A6A6A] font-Urbanist text-[16px] font-medium leading-[140%]">
                Enter these details for your preferences
              </p>
            </div>
            {/* Close Button */}
            <div
              className="absolute top-6 right-6 h-[36px] w-[36px] cursor-pointer border rounded-full p-[7px] bg-white flex items-center justify-center"
              onClick={onClose}
            >
              <img src={cancel} alt="Close" className="h-[18px] w-[18px]" />
            </div>

            {/* Name Field */}
            <div className="my-[30px]">
              <label className="text-[#050505] font-Urbanist text-[16px] font-medium leading-[140%] ">
                What should we call you?
              </label>
              <input
                type="text"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                className="w-full flex p-4 items-center gap-3 self-stretch rounded-[16px] border border-[#E5E5E5] bg-white shadow-[0_1px_4px_0_rgba(229,229,229,0.40)]"
                placeholder="Enter your full name mt-[12px]"
              />
            </div>

            <div className="mb-[100px]">
              <h6 className="text-[#050505] font-Urbanist text-[16px] font-medium leading-[140%] mb-[12px]">
                Select your preferences
              </h6>

              <div className="flex flex-wrap gap-3">
                {categories.map((item, index) => {
                  const isSelected = selectedCategories.includes(item);
                  return (
                    <button
                      key={index}
                      onClick={() => toggleCategory(item)}
                      className={`px-5 py-2 text-sm font-medium rounded-full border transition ${
                        isSelected
                          ? "bg-[#7604A5] text-white border-[#7604A5]"
                          : "border-gray-300 text-gray-600 hover:bg-gray-50"
                      }`}
                    >
                      {item}
                    </button>
                  );
                })}
              </div>
            </div>

            {/* Get Started Button */}
            <button
            //   onClick={handleGetStarted}
              className="w-full flex items-center justify-between py-4 px-6 bg-[#FF8A00] rounded-[150px] cursor-pointer hover:bg-[#5f0289] transition-colors"
            >
              <span className="text-white font-Urbanist text-[20px] font-semibold leading-[140%]">
                Get Started
              </span>
              <div className="h-[42px] w-[42px] flex justify-center items-center bg-white rounded-full">
                <img
                  src={arrow}
                  alt="right arrow"
                  className="h-[41px] w-[30px] stroke-[2.587px] stroke-[#FB8606]"
                />
              </div>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Welcome;
